<template>
    <div v-if="testimonials?.testimonials?.length>0">
        <div class="uk-section uk-section-small uk-light uk-text-center" v-if="testimonials.title">
            <h2>{{testimonials.title}}</h2>
        </div>

        <div class="uk-background-muted-light uk-light testimonials">
                <div class="uk-position-relative uk-visible-toggle" uk-slider v-keyboard-slide>

                    <ul class="uk-slider-items">
                        <li v-bind:class="photos ? 'uk-width-1-1' : 'uk-width-4-5@m'" v-for="(testimonial, index) in testimonials.testimonials" :key="'testimonial' + index">
                            <div class="uk-flex uk-grid-collapse" uk-grid>
                                <div v-if="photos" class="uk-width-1-3@m uk-width-1-4@l">
                                    <img :src="imageName(index)" />
                                </div>
                                <div v-bind:class="photos ? 'uk-width-1-3@m uk-width-1-2@l': 'uk-width-2-3@l'">
                                    <div class="uk-padding-large testimonial-text">
                                        <h3>{{testimonial.Text}}</h3>
                                    </div>
                                </div>
                                <div class="uk-width-1-3@m uk-width-1-4@l uk-text-bottom ">
                                    <div class="uk-padding-large">
                                        <component :is="testimonial.Link ? 'a' : 'span'" class="clean" :href="testimonial.Link" target="_blank">
                                        <h4 class="uk-text-uppercase text-light-blue"><b>{{testimonial.Name}}</b></h4>
                                        <em class="text-light-blue">- {{testimonial.title}}</em>
                                        </component>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>

                    <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="#" uk-slidenav-previous uk-slider-item="previous" ref="previous"></a>
                    <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="#" uk-slidenav-next uk-slider-item="next" ref="next"></a>

                </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['testimonials', 'photos'],
    inject: ['theme'],
    methods: {
        imageName(index) {
            let i = index+1;
            return `${this.theme}/app/assets/images/tiles/tile${i}.jpg`
        }
    }
}
</script>
